export default "__VITE_ASSET__Dgsd3Ebo__"